class Collection {
	constructor() {
		this.nostoGQLEndpoint = 'https://search.nosto.com/v1/graphql';
		this.imagePlaceholder = 'data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 3 2\'%3E%3C/svg%3E';
		this.nostoKey = window.nostoSettings.key;
		this.accountId = window.nostoSettings.accountId;
		this.nostoGQLHeaders = {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${this.nostoKey}`,
			}
		};

    this.perPage = window.perPage;

		this.selector = {
			bottomPagination: "#nosto-bottom-pagination"
		};

    this.swatchData = null;

		this.commaDecimalCurrencies = ['EUR'];

		this.sizeMapping = []

		this.sizeSortRanking = window.sizeRankingSettings

		this.initialProducts = null;
		this.fetchingProducts = false;
		this.totalProducts = '';
		this.refineByMobileSwpr = null;
    this.$resultsCount = document.querySelector('[data-results-count]');

		this.init();
	}

	init() {
    this.loadingStateContainer = document.getElementById('products');
    this.loadingStateStart();

		if (this.isReady()) {
			this.initializeSortOrder();
			this.bindFacetButtons();
			this.bindFacetSelectionBoxes();
			this.bindFacetSelectionSliders();
			this.bindPaginationNextButtons();
			this.bindPaginationPrevButtons();
			this.bindPaginationJumpButtons();
			this.bindRemoveFilterButtons();
			this.bindSortSelect();
			this.bindRemoveAllFilters();
			this.createSearchPageHeader();

			if (!this.fetchingProducts) {
				this.updateVisibleProducts();
			}

      if (window.swatchDataNodes) {
        this.initFilters();
      } else {
        document.addEventListener('swatchDataReady', () => {
          this.initFilters();
        })
      }

			this.closeMenuDesktop();
		} else {
			this.updateVisibleProducts();
		}
	}

	isReady() {
		return document.querySelector('[data-nosto-collection]');
	}

	closeMenuDesktop() {
    document.addEventListener('click', e => {
      if (!e.target.closest('[data-collections-filter-view]')) return;

      const $active = document.querySelector('[data-collection-facet-button].active');
      if ($active) $active.classList.remove('active');

      const $filterMenu = document.querySelector('[data-collection-filter-menu]');
      if ($filterMenu) $filterMenu.classList.remove('active');
    });
	}

	bindSortSelect() {
    document.addEventListener('change', e => {
      const el = e.target.closest('[name="sort_by"]');
      if (!el) return;

      document.querySelector('#collection-sort-select').value = el.value;

			this.updateStateQueryParams();
			this.updateVisibleProducts();
    });
	}

	bindFacetButtons() {
    document.addEventListener('click', e => {
      const el = e.target.closest('[data-collection-facet-button]');

      if (!el) return;

			const clickedFacetName = el.dataset.facetName;

      document.querySelector(`[data-collection-facet-button][data-facet-name*="${clickedFacetName}"]`)?.classList.remove('active');
			document.querySelector(`[data-collection-facet-button][data-facet-name*="${clickedFacetName}"]`)?.classList.remove('active');
			document.querySelector(`[data-collection-facet-button][data-facet-name="${clickedFacetName}"]`)?.classList.toggle('active');
			document.querySelector(`[data-collection-filter-menu][data-facet-name*="${clickedFacetName}"]`)?.classList.remove('active');
			document.querySelector(`[data-collection-filter-menu][data-facet-name*="${clickedFacetName}"]`)?.classList.toggle('active');
    });
	}

	bindFacetSelectionBoxes() {
    document.addEventListener('click', e => {
      const el = e.target.closest('[data-collection-facet-checkbox]');

      if (!el) return;

			el.classList.toggle('checked');
			this.buildFilterClearButtons();
			this.updateStateQueryParams();
			this.updateVisibleProducts();
		})
	}

	bindFacetSelectionSliders() {
    document.addEventListener('input', e => {
      const el = e.target.closest('[data-facet-slider-control] [data-from-slider]');

      if (el) {
        const parentContainer = el.closest(".collection__facet-range-container");
        const fromDisplay = parentContainer.querySelector('[data-from-display]');
        fromDisplay.innerHTML = (el.value);
      }

      const controlEl = e.target.closest('[data-facet-slider-control] [data-from-slider]');

      if (controlEl) {
        const parentContainer = controlEl.closest(".collection__facet-range-container");
        const toDisplay = parentContainer.querySelector('[data-to-display]');
        toDisplay.html(controlEl.value);
      }
    });

		document.addEventListener('mouseup', e => {
      if (!e.target.closest('[data-facet-slider-control] [data-from-slider], [data-facet-slider-control] [data-to-slider]')) return;

			this.buildFilterClearButtons();
			this.updateStateQueryParams();
			this.updateVisibleProducts();
		})
	}

	bindPaginationNextButtons() {
    document.addEventListener('click', e => {
      if (!e.target.closest('[data-next-page-button]')) return;

			const urlParams = new URLSearchParams(window.location.search);
			let currentPage = urlParams.get('page');
			if (currentPage) {
				urlParams.set('page', parseInt(currentPage) + 1);
			} else {
				urlParams.set('page', 2);
			}

			let newUrl = window.location.href.split('?')[0];
			const urlParamString = urlParams.toString();
			if (urlParamString.length > 0) {
				newUrl += '?' + urlParamString;
			}

			window.history.pushState({}, null, newUrl);
			document.body.scrollTop = document.documentElement.scrollTop = 0;
			this.updateVisibleProducts();
		})
	}

	bindPaginationPrevButtons() {
    document.addEventListener('click', e => {
      if (!e.target.closest('[data-prev-page-button]')) return;

			const urlParams = new URLSearchParams(window.location.search);
			let currentPage = urlParams.get('page');

			if (currentPage) {
				if (currentPage == 2) {
					urlParams.delete('page');
				} else {
					urlParams.set('page', parseInt(currentPage) - 1);
				}

				let newUrl = window.location.href.split('?')[0];
				const urlParamString = urlParams.toString();
				if (urlParamString.length > 0) {
					newUrl += '?' + urlParamString;
				}

				window.history.pushState({}, null, newUrl);
				document.body.scrollTop = document.documentElement.scrollTop = 0;
				this.updateVisibleProducts();
			}
		})
	}

	bindPaginationJumpButtons() {
    document.addEventListener('click', e => {
      const el = e.target.closest('[data-jump-page-button]');

      if (!el) return;

			if (el.hasAttribute('data-page-num')) {
				const urlParams = new URLSearchParams(window.location.search);
				if (parseFloat(el.dataset.pageNum) > 1) {
					urlParams.set('page', el.dataset.pageNum);
				} else {
					urlParams.delete('page');
				}

				let newUrl = window.location.href.split('?')[0];
				const urlParamString = urlParams.toString();
				if (urlParamString.length > 0) {
					newUrl += '?' + urlParamString;
				}

				window.history.pushState({}, null, newUrl);
				document.body.scrollTop = document.documentElement.scrollTop = 0;
				this.updateVisibleProducts();
			};
		});
	}

	bindRemoveFilterButtons() {
    document.addEventListener('click', e => {
      if (!e.target.closest('[data-header-refine-by] button')) return;

			const currentTarget = e.currentTarget;
			const filterToRemove = currentTarget.data('facetValue');
			if (typeof currentTarget.getAttribute('sliderClear') !== 'undefined') {
				const facetName = currentTarget.dataset.facetName;
				this.clearRangeFilter(facetName);
				this.buildFilterClearButtons();
				this.updateStateQueryParams();
				this.updateVisibleProducts();
			} else {
				document.querySelector(`[data-collection-facet-checkbox][data-facet-value="${filterToRemove}"].checked`)?.click();
			}
		})
	}

	bindRemoveAllFilters() {
    document.addEventListener('click', e => {
      if (!e.target.closest('[data-collections-filter-clear]')) return;

			this.removeAllFilters();
		})
	}

	resetRangeFilters() {
		document.querySelectorAll('[data-from-slider]').forEach(slider => {
			slider.value = slider.min;
			const parentContainer = slider.closest(".collection__facet-range-container");
      if (!parentContainer) return;

			const fromDisplay = parentContainer.querySelector('[data-from-display]');
			fromDisplay.innerHTML = slider.value;
		});

		document.querySelectorAll('[data-to-slider]').forEach(slider => {
			slider.value = slider.max;
			const parentContainer = slider.closest('.collection__facet-range-container');
      if (!parentContainer) return;

			const toDisplay = parentContainer.querySelector('[data-to-display]');
			toDisplay.innerHTML = slider.value;
		})
	}

	clearRangeFilter(facetName) {
		const filterContainer = document.querySelector(`[data-facet-slider-control][data-facet-name=${facetName}]`);
		if (!filterContainer) return;

    const fromSlider = filterContainer.querySelector('[data-from-slider]')
    if (fromSlider) {
      fromSlider.value = fromSlider.min;
      const parentContainer = fromSlider.closest('.collection__facet-range-container');
      const fromDisplay = parentContainer.querySelector('[data-from-display]');
      fromDisplay.innerHTML = currentTarget.value;
    }

    const toSlider = filterContainer.querySelector('[data-to-slider]');
    if (toSlider) {
      toSlider.value = toSlider.max;
      const parentContainer = slider.closest('.collection__facet-range-container');
      const toDisplay = parentContainer.querySelector('[data-to-display]');
      toDisplay.innerHTML = currentTarget.value;
    }
	}

	removeAllFilters() {
    const els = document.querySelectorAll('[data-collection-facet-checkbox][data-facet-value].checked');
		els.forEach(el => el.classList.remove('checked'));
		this.resetRangeFilters();
		this.buildFilterClearButtons();
		this.updateStateQueryParams();
		this.updateVisibleProducts();
	}

	getCurrentPage() {
		const urlParams = new URLSearchParams(window.location.search);

		let currentPage = urlParams.get('page');

		if (!currentPage) {
			currentPage = 1;
		}

		if (!isNaN(currentPage)) {
			currentPage = parseInt(currentPage);
		} else {
			currentPage = 1;
		}

		if (currentPage < 1) {
			currentPage = 1;
		}

		return currentPage;
	}

	getActiveFilters() {
		// Get Active Filters For Nosto Query
		const activeFiltersDict = {}
    if (window.nostoSettings.searchResultsHideUnavailable) activeFiltersDict.availability = ['InStock'];

		const rangeFilters = {};

		const url = new URL(window.location.href);
		const searchParams = new URLSearchParams(url.search);

		for (const param of searchParams) {
			const key = param[0];

			if (key.startsWith('filter.')) {
				const newKey = key.split('filter.')[1];
				const newValues = param[1].split(',');
				activeFiltersDict[newKey] = newValues;
			}


			if (key.startsWith('filterRange.')) {
				const splitKey = key.split('.');
				const rangeValue = param[1];

				if (splitKey.length === 3) {
					const rangeKey = splitKey[1];
					const rangeTitle = splitKey[2];

					if (!(rangeTitle in rangeFilters)) {
						rangeFilters[rangeTitle] = {};
					}

					rangeFilters[rangeTitle][rangeKey] = rangeValue;
				}
			}
		}

		const activeFilters = [];

		Object.keys(activeFiltersDict).forEach(key => {
			const currentValues = activeFiltersDict[key];
			let newValues = currentValues;

			if (key === 'skus.customFields.size') {
				newValues = [];
				currentValues.forEach(value => {
					newValues.push(value);
					const sizeMappingKeys = Object.keys(this.sizeMapping);
					const filteredDictValues = sizeMappingKeys.filter(key => this.sizeMapping[key] === value);
					if (filteredDictValues.length > 0) {
						newValues = newValues.concat(filteredDictValues);
					}
				});
			};

			activeFilters.push({field: key, value: newValues});
		})

		Object.keys(rangeFilters).forEach(key => {
			activeFilters.push({field: key, range: rangeFilters[key]})
		});

		return activeFilters;
	}

	initializeSortOrder() {
		const url = new URL(window.location.href);
		const searchParams = new URLSearchParams(url.search);
		const sortParam = searchParams.get('sortOrder');

		if (sortParam) {
      const select = document.querySelector('#collection-sort-select');
			if (select) select.value = sortParam;

      const radio = document.querySelector(`[name="sort_by"][value="${sortParam}"]`);
      if (radio) radio.checked = true;
		}
	}

	getSortOrder() {
    const el = document.querySelector('#collection-sort-select');
    if (!el) return;

    const sortOrderValue = el.value;
		let sortOrder = [];

		switch(sortOrderValue) {
			case 'newest':
				sortOrder = [{field: 'datePublished', order: 'desc'}]
				break
			case 'low-high':
				sortOrder = [{field: 'price', order: 'asc'}]
				break
			case 'high-low':
				sortOrder = [{field: 'price', order: 'desc'}]
				break
		}

		return sortOrder;
	}

	getSearchPageFacetRequestBody() {
		const nostoQuery = `
      query($queryString: String) {
        search(
          accountId: "${this.accountId}"
					query: $queryString
					products: {
						size: ${this.perPage},
					}
				) {
					products {
						facets {
							... on SearchTermsFacet {
								id
								field
								type
								name
								data {
									value
									count
									selected
								}
							}
							... on SearchStatsFacet {
								id
								field
								type
								name
								min
								max
							}
						}
						total
						size
						searchType
					}
				}
			}
		`;

		const urlParams = new URLSearchParams(window.location.search);
		const searchQuery = urlParams.get('q');

		const requestBody = {
			'query': nostoQuery,
			'variables': {
				'queryString': searchQuery ? searchQuery : ''
			}
		};

		return requestBody;
	}

	getSearchPageNostoRequestBody(currentPage, activeFilters, sortOrder) {
		const nostoQuery = `
			query($queryString: String, $filters: [InputSearchTopLevelFilter!], $sortOrder: [InputSearchSort!]) {
				search(
					accountId: "${this.accountId}"
					query: $queryString
					products: {
						size: ${this.perPage},
						from: ${(currentPage - 1) * this.perPage},
						filter: $filters,
						sort: $sortOrder
					}
				) {
					products {
						hits {
							url
							productId
							name
							imageUrl
							thumbUrl
							brand
							availability
							price
							listPrice
							categoryIds
							inventoryLevel
							tags1
							tags2
							tags3
							priceCurrencyCode
							alternateImageUrls
							skus {
								id
								name
								price
								url
								imageUrl
								availability
								customFields {
									key
									value
								}
							}
							customFields {
								key
								value
							}
						}
						total
						size
						searchType
					}
				}
			}
		`

		const urlParams = new URLSearchParams(window.location.search);
		const searchQuery = urlParams.get('q');

		const requestBody = {
			'query': nostoQuery,
			'variables': {
				'queryString': searchQuery ? searchQuery : '',
				'filters': activeFilters,
				'sortOrder': sortOrder,
			}
		}

		return requestBody;
	}

	updateStateQueryParams() {
		// Remove non-active filter query params
		const url = new URL(window.location.href);
		const searchParams = new URLSearchParams(url.search);
		let paramsToRemove = ['page'];

		for (const param of searchParams) {
			const key = param[0];

			if (key.startsWith('filter.') || key.startsWith('filterRange.')) {
				paramsToRemove.push(key);
			}
		}

		paramsToRemove.forEach(param => {
			searchParams.delete(param);
		});

		// Add each filter value to url based on active filter checkboxes
		const activeFiltersDict = {};

		document.querySelectorAll('[data-collection-facet-checkbox].checked').forEach(checkbox => {
			const field = checkbox.dataset.facetName;
			const value = checkbox.dataset.facetValue;

			if (field in activeFiltersDict) {
				activeFiltersDict[field].push(value);
			} else {
				activeFiltersDict[field] = [value];
			}
		});

		const activeFilters = []
		Object.keys(activeFiltersDict).forEach(key => {
			activeFilters.push({field: key, value: activeFiltersDict[key]});
		});

		activeFilters.forEach(filter => {
			const newKey = 'filter.' + filter.field;
			const fieldValuesJoined = filter.value.join(',');

			searchParams.append(newKey, fieldValuesJoined);
		});

		// Check slider filters
		const facetSliders = document.querySelectorAll('[data-facet-slider-control]');

		facetSliders.forEach(slider => {
			const fromSlider = slider.querySelector('[data-from-slider]');
			const toSlider = slider.querySelector('[data-to-slider]');

			if (fromSlider && toSlider) {
				const fromValue = fromSlider.value;
				const fromMin = fromSlider.min;

				if (fromValue != fromMin) {
					const newKey = 'filterRange.gte.' + slider.dataset.facetName;
					const fieldValue = fromValue;
					searchParams.append(newKey, fieldValue);
				}

				const toValue = toSlider.value;
				const toMax = toSlider.max;

				if (toValue != toMax) {
					const newKey = 'filterRange.lte.' + slider.dataset.facetName;
					const fieldValue = toValue;
					searchParams.append(newKey, fieldValue);
				}
			}
		})

		const selectedSortOption = document.querySelector('#collection-sort-select').value;

		if (selectedSortOption !== 'featured') {
			searchParams.set('sortOrder', selectedSortOption);
		} else {
			searchParams.delete('sortOrder');
		}

		let newPageUrl = window.location.href.split('?')[0];
		const searchParamString = searchParams.toString();

		if (searchParamString.length > 0) {
			newPageUrl += '?' + searchParams.toString();
		}

		window.history.pushState({}, null, newPageUrl);
	}

	updateVisibleProducts() {
		this.fetchingProducts = true;

		if (this.isReady() && this.initialProducts) {
			this.visibleProductsCallback(this.initialProducts, this.totalProducts);
			this.initialProducts = null;
			return;
		}

		const currentPage = this.getCurrentPage();
		const activeFilters = this.getActiveFilters();
		const from = (currentPage - 1) * this.perPage;
		const sortOrder = this.getSortOrder();
    const requestBody = this.getSearchPageNostoRequestBody(currentPage, activeFilters, sortOrder);

		axios.post(this.nostoGQLEndpoint, requestBody, this.nostoGQLHeaders).then(res => {
      const products = res.data.data.search.products.hits;
      const totalProducts = res.data.data.search.products.total;
      this.totalProducts = totalProducts;

      try {
        this.sendCategoryNostoAnalytics(res, activeFilters, sortOrder, from);
      } catch(e) {
        console.error(e);
      }

      this.updateProductCount();

      if (this.isReady()) {
        this.visibleProductsCallback(products, totalProducts);
      } else {
        this.initialProducts = products;
      }

      this.fetchingProducts = false;
    });
	}

	visibleProductsCallback(products, totalProducts) {
		this.buildProductCards(products);
		this.buildPagination(totalProducts);
	}

	buildFilterClearButtons() {
		const refineBy = document.querySelector('[data-header-refine-by');

    if (!refineBy) return;

		refineBy.innerHTML = '';

    document.querySelectorAll('[data-collection-facet-checkbox].checked').forEach(el => {
			const filter = el;
      const button = document.createElement('button');
      button.dataset.facetName = filter.dataset.facetName;
      button.dataset.facetValue = filter.dataset.facetValue;
      button.innerHTML = `
        <small class="visually-hidden">Remove</small>
        ${filter.dataset.facetValue}
        <span>
          <svg version="1.1" aria-hidden="true" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" xml:space="preserve">
            <line fill:none" stroke="#231F20" x1="0.65" y1="0.5" x2="9.35" y2="9.5"/>
            <line fill:none" stroke="#231F20" x1="0.5" y1="9.35" x2="9.5" y2="0.65"/>
          </svg>
        </span>
			`;

			refineBy.appendChild(button);
		})

		const filterSliderContainers = document.querySelectorAll('[data-facet-slider-control]');

		filterSliderContainers.forEach(el => {
			const fromSlider = el.querySelector('[data-from-slider]');
			const toSlider = el.querySelector('[data-to-slider]');

			if (fromSlider && toSlider) {
				if (fromSlider.value != fromSlider.min || toSlider.value != toSlider.max) {
          const button = document.createElement('button');
          button.dataset.facetName = el.dataset.facetName;
          button.dataset.sliderClear = '';
          button.innerHTML = `
							<small class="visually-hidden">Remove</small>
							$${fromSlider.value} - $${toSlider.value}
							<span>
								<svg version="1.1" aria-hidden="true" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" xml:space="preserve">
									<line fill:none" stroke="#231F20" x1="0.65" y1="0.5" x2="9.35" y2="9.5"/>
									<line fill:none" stroke="#231F20" x1="0.5" y1="9.35" x2="9.5" y2="0.65"/>
								</svg>
							</span>
					`;

          refineBy.appendChild(button);
				}
			}
		});
	}

	buildFilters(facets) {
		facets = facets.filter(facet => {
			if (facet.name) {
				if (window.disabledNostoFilters) {
					const disabledNostoFilters = window.disabledNostoFilters
					if (disabledNostoFilters.length > 0) {
						if (disabledNostoFilters.includes(facet.name.toLowerCase())) {
							return false
						}
					}
				}
			}
			return true
		})

		const filterContainer = document.querySelector('[data-collection-filters-desktop]')
		const filterMenuContainer = document.querySelector('[data-collection-filter-menu-container]')
		if (!(filterContainer && filterMenuContainer)) return;

    if (filterContainer.childElementCount === 0) {
      facets.forEach(facet => {
				let facetSkip = false;

				if (facet.data && facet.data.length <= 1) {
					facetSkip = true;
				}
        const isSwatch = facet.field === 'extra.filter-swatch';

				if (facet.field && !facetSkip) {
          const filterMarkup = `<button class="collection__facet-button" data-collection-facet-button data-facet-name="${facet.field}" id="filter-${this.handleize(facet.field)}">${facet.name}</button>`
          const newElement = this.createElementFromHTML(filterMarkup)
          filterContainer.appendChild(newElement)
          let filterOptions = ''
          if (facet.type === 'terms') {
            let uniqueOptionValues = facet.data.map(option => option.value)
            if (facet.field === 'skus.customFields.size') {
              uniqueOptionValues = []
              facet.data.forEach(option => {
                let mappedOption = option.value
                if (option.value in this.sizeMapping) {
                  mappedOption = this.sizeMapping[option.value]
                }
                if (!uniqueOptionValues.includes(mappedOption)) {
                  uniqueOptionValues.push(mappedOption)
                }
              })
              uniqueOptionValues.sort((a, b) => {
                const aIndex = this.sizeSortRanking.includes(a)? this.sizeSortRanking.indexOf(a): '500'
                const bIndex = this.sizeSortRanking.includes(b)? this.sizeSortRanking.indexOf(b): '500'
                return aIndex - bIndex
              })
            }

            uniqueOptionValues.forEach(option => {
              let optionLabel = option

              if (isSwatch) {
                optionLabel = this.renderSwatch(option);
              }

              const optionMarkup = `
                <div class="collection__facet-selection-item" role="presentation">
                  <button
                    class="filters__label collection__facet-selection-checkbox"
                    data-facet-name="${facet.field}"
                    data-facet-value="${option}"
                    data-collection-facet-checkbox
                    aria-checked="false"
                    role="checkbox"
                  >${optionLabel}</button>
                </div>
              `
              filterOptions += optionMarkup
            })

            filterOptions = `<div class="flex flex--column filter-${this.handleize(facet.name) === 'waist' || this.handleize(facet.name) === 'inseam' ? 'size' : this.handleize(facet.name)}" id="filter-menu-${this.handleize(facet.name)}" style="gap: var(--gap, 16px)">` + filterOptions + '</div>'
          } else if (facet.type === 'stats') {
            const facetMin = Math.floor(facet.min)
            const facetMax = Math.ceil(facet.max)

            filterOptions += `
              <div class="filters__group-block filters__group-block--text">
                <div class="sliders_control" data-facet-slider-control data-facet-name="${facet.field}">
                  <input class="from-slider" data-from-slider type="range" value="${facetMin}" min="${facetMin}" max="${facetMax}"/>
                  <input class="to-slider" data-to-slider type="range" value="${facetMax}" min="${facetMin}" max="${facetMax}"/>
                </div>
                <div class="sliders-display" data-facet-name="${facet.field}">
                  <span data-from-display>${facetMin}</span>
                  <span data-to-display>${facetMax}</span>
                </div>
              </div>
            `

            filterOptions = filterOptions
          }

          const filterMenuMarkup = `
            <details class="filters__group accordion flex flex--column"
              data-facet-name="${facet.field}"
              data-collection-filter-menu
              role="group"
              aria-labelledby="filter-${this.handleize(facet.field)}"
              data-filter="${facet.field}"
              ontoggle="
                const isOpen = this.open;
                this.classList[isOpen ? 'add' : 'remove']('open');
                window.openedFilters = window.openedFilters || {};
                openedFilters['{{ filter.label | escape }}'] = isOpen;
              ">
              <summary class="filters__group-title flex-shrink full-width font-weight lh-1 position--relative pseudo-plus-icon tt--upper user-select"
                style="
                  --font-weight: 500;
                  --pseudo-plus-icon-right: 0;
                  font-size: 16px;
                ">
                ${facet.name.toString()}
              </summary>
              <div class="filters__group-content padding"
                style="
                  --padding-desktop: 10px 0 32px;
                  --padding-mobile: 10px 0 32px;
                ">
                ${filterOptions}
              </div>
            </details>
          `

          const newMenu = this.createElementFromHTML(filterMenuMarkup)
          filterMenuContainer.appendChild(newMenu)
        }
      })
    } else {
      const refineBy = document.querySelector('[data-header-refine-by');
      if (!refineBy) return;

      refineBy.innerHTML = '';

      document.querySelectorAll('[data-collection-facet-checkbox].checked').forEach(el => {
        const filter = el;
        const button = document.createElement('button');
        button.dataset.facetName = filter.dataset.facetName;
        button.dataset.facetValue = filter.dataset.facetValue;
        button.dataset.sliderClear = '';
        button.innerHTML = `
          <small class="visually-hidden">Remove</small>
          ${filter.data('facet-value')}
          <span>
            <svg version="1.1" aria-hidden="true" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" xml:space="preserve">
              <line fill:none" stroke="#231F20" x1="0.65" y1="0.5" x2="9.35" y2="9.5"/>
              <line fill:none" stroke="#231F20" x1="0.5" y1="9.35" x2="9.5" y2="0.65"/>
            </svg>
          </span>
        `
        refineBy.appendChild(button);
      })
    }
	}

  renderSwatch(id) {
    const swatch = window.swatchDataNodes.find(swatch => swatch.node.id === id);
    const data = swatchData[swatch.node.handle];
    const markup = `
      <span aria-hidden="true">${data.label}</span>
      <span style="
        border-radius: 50%;
        border: 1px solid var(--swatch-border-color, #E3E3E3);
        pointer-events: none;
        background-color: ${data.color};
        ${data.imageUrl && `
          background-image: url(${data.imageUrl});
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        `}
        display: inline-block;
        height: 14px;
        margin: 0 37px 0 7px;
        width: 14px;
      "></span>
    `;

    return markup
  }

  updateProductCount() {
    if (this.totalProducts > 0) {
      this.$resultsCount.innerText = `${this.totalProducts} products`;
      this.$resultsCount.classList.add('active');
    } else {
      this.$resultsCount.classList.remove('active');
      this.$resultsCount.innerText = '';
    }
  }

	createSearchPageHeader() {
		if (!window.isNostoSearchPage) return;

    const urlParams = new URLSearchParams(window.location.search);
    const query = urlParams.get('q');
    const collectionTitleContainer = document.querySelector('[data-collection-title-wrapper]');

    if (collectionTitleContainer) {
      requestAnimationFrame(() => {
        const text = `Search Results${query ? ` for "${query}"` : ''}`;
        collectionTitleContainer.innerText = text;
        this.updateTitle(`${text} | mnml`);
      });
    }
	}

	handleize(str) {
		str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '') // Remove accents
		.replace(/([^\w]+|\s+)/g, '-') // Replace space and other characters by hyphen
		.replace(/\-\-+/g, '-')	// Replaces multiple hyphens by one hyphen
		.replace(/(^-+|-+$)/g, '') // Remove extra hyphens from beginning or end of the string
		.toLowerCase() // To lowercase

		return str
	}

	initFilters() {
    const requestBody = this.getSearchPageFacetRequestBody();

		axios.post(this.nostoGQLEndpoint, requestBody, this.nostoGQLHeaders).then(res => {
			const facets = res.data.data.search.products.facets;
			this.buildFilters(facets);
			this.selectFiltersFromQueryParams();
			this.buildFilterClearButtons();
		});
	}

  loadingStateEnd() {
    this.loadingStateContainer.classList.remove('products--loading');
  }

  loadingStateStart() {
    this.loadingStateContainer.classList.add('products--loading');
  }

	selectFiltersFromQueryParams() {
		const restoredFilters = []
		const restoredRangeFilters = []
		const url = new URL(window.location.href)
		const searchParams = new URLSearchParams(url.search)

		for (const param of searchParams) {
			const key = param[0]

			if (key.startsWith('filter.')) {
				const newKey = key.split('filter.')[1]
				const newValue = param[1].split(',')
				restoredFilters.push({field: newKey, value: newValue})
			}

			if (key.startsWith('filterRange.')) {
				const splitKey = key.split('.')

				if (splitKey.length === 3) {
					const rangeType = splitKey[1]
					const rangeTitle = splitKey[2]
					const value = param[1]
					restoredRangeFilters.push({field: rangeTitle, type: rangeType, value: value})
				}
			}
		}

		restoredFilters.forEach(filter => {
			filter.value.forEach(filterValue => {
        const el = document.querySelector(`[data-collection-facet-checkbox][data-facet-name="${filter.field}"][data-facet-value="${filterValue}"]`);
        if (!el) return;

        el.classList.add('checked')
        el.setAttribute('aria-checked', 'true');
			});
		})

		restoredRangeFilters.forEach(filter => {
			const sliderContainer = document.querySelector(`[data-facet-slider-control][data-facet-name=${filter.field}]`);
			const parentContainer = sliderContainer.parentElement;

			if (sliderContainer) {
				if (filter.type === 'gte') {
					const fromSlider = sliderContainer.querySelector('[data-from-slider]')
					const fromDisplay = parentContainer.querySelector('[data-from-display]')

					if (fromSlider && fromDisplay) {
						fromSlider.value = filter.value
						fromDisplay.innerHTML = filter.value
					}
				} else {
					const toSlider = sliderContainer.querySelector('[data-to-slider]')
					const toDisplay = parentContainer.querySelector('[data-to-display]')

					if (toSlider && toDisplay) {
						toSlider.value = filter.value
						toDisplay.innerHTML = filter.value
					}
				}
			}
		})
	}

  updateTitle(string) {
    document.title = string;
  }

	buildProductCards(products) {
		const $collection = document.querySelector('[data-nosto-collection]');
		if (!$collection) return;

    $collection.innerHTML = '';

    // Create no results page if no products
    if (products.length === 0) {
      $collection.innerHTML = `
        <div class="search__empty"
          style="
            grid-column: span 6;
            overflow: hidden;
          ">
          <p>${window.emptySearchText}</p>
          ${window.noResultsNosto ? `<div class="padding-top--l">${window.noResultsNosto}</div>` : ''}
        </div>
      `;

      if (window.nostojs) {
        window.nostojs((api) => {
          api.loadRecommendations();
        })
      }

      requestAnimationFrame(() => {
        this.loadingStateEnd();
      });

      return;
    }

    let fetchedCounter = 0;
    let markup = '';
    let markupObj = {};

    products.forEach((product, index) => {
      fetch(`${product.url}?view=fetch-sections&sections=product-card`)
        .then(response => response.json())
        .then(data => {
          fetchedCounter++;

          markupObj[index] = new DOMParser()
            .parseFromString(data['product-card'], 'text/html')
            .getElementById('shopify-section-product-card').innerHTML;

          if (fetchedCounter === products.length) {
              Object.keys(markupObj).sort((key1, key2) => {
              if (key1 < key2) return -1;
              if (key1 > key2) return 1;
              return 0;
            });

            for (const [key, value] of Object.entries(markupObj)) {
              markup += value;
            }

            $collection.innerHTML = markup

            requestAnimationFrame(() => {
              this.loadingStateEnd();
            });
          }
        });
    });
	}

	preloadImage(url) {
	  const image = new Image()
	  image.src = url
	}

	trimSizeName(name) {
	  name = name.replace('AU', '')
	  name = name.replace('US', '')
	  name = name.replace('iPhone', '')
	  name = name.replace('SHOE', '')
	  name = name.replace('One Size', 'ONE SIZE')
	  name = name.replace('ONE SIZE', 'ONE SIZE')
	  return name.trim()
	}

	createElementFromHTML(htmlString) {
		const div = document.createElement('div')
		div.innerHTML = htmlString.trim()

		// Change this to div.childNodes to support multiple top-level nodes.
		return div.firstChild
	}

	paginationTemplate() {
		return `
			<nav class="paginate" aria-label="pagination" style="display: none;">
				<div class="paginate__viewed">You've Viewed <strong>{{viewingLast}}</strong> of <strong>{{totalProduct}}</strong> Styles</div>
				<div class="paginate__progress">
					<div class="paginate__progress-bar" style="width: {{progress}};"></div>
				</div>
			</nav>
      <div class="pagination flex flex--row flex--align-center flex--justify-center margin padding-bottom--m padding-top--m"
        style="
          font-size: 12px;
          gap: 8px;
        ">
        {{previous}}{{pageItems}}{{next}}
      </div>
		`
	}

	previousActiveHtmlTemplate() {
		return `
			<!-- <span class="page">
				<button data-prev-page-button class="paginate__link paginate__link--prev" aria-label="Page Previous">
					<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="50px" height="50px" viewBox="0 0 50 50" xml:space="preserve">
						<circle fill="#ffffff" cx="25" cy="25" r="25"/>
						<polygon fill="#231f20" points="27.628,15.126 22.086,24.087 21.764,24.617 22.069,25.157 27.689,34.891 25.583,34.891 19.633,24.652 25.566,15.126" />
					</svg>
				</button>
			</span> -->
		`
	}

	previousDisabledHtmlTemplate() {
		return `
			<!-- <span class="page">
				<button type="button class="paginate__link paginate__link--prev paginate__link--disabled" aria-label="Page Previous" disabled>
					<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="50px" height="50px" viewBox="0 0 50 50" xml:space="preserve">
						<circle fill="#ffffff" cx="25" cy="25" r="25"/>
						<polygon fill="#231f20" points="27.628,15.126 22.086,24.087 21.764,24.617 22.069,25.157 27.689,34.891 25.583,34.891 19.633,24.652 25.566,15.126" />
					</svg>
				</button>
			</span> -->
		`
	}

	nextActiveHtmlTemplate() {
		return `
			<!-- <span class="page">
				<button type="button data-next-page-button class="paginate__link paginate__link--next" aria-label="Page Next">
					<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="50px" height="50px" viewBox="0 0 50 50" xml:space="preserve">
						<circle fill="#ffffff" cx="25" cy="25" r="25"/>
						<polygon fill="#231f20" points="22.373,15.126 27.914,24.087 28.236,24.617 27.932,25.157 22.312,34.891 24.417,34.891 30.368,24.652 24.435,15.126" />
					</svg>
				</button>
			</span> -->
		`
	}

	nextDisabledHtmlTemplate() {
		return `
			<!-- <span class="page">
				<button type="button" class="paginate__link paginate__link--next paginate__link--disabled" aria-label="Page Next" disabled>
					<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="50px" height="50px" viewBox="0 0 50 50" xml:space="preserve">
						<circle fill="#ffffff" cx="25" cy="25" r="25"/>
						<polygon fill="#231f20" points="22.373,15.126 27.914,24.087 28.236,24.617 27.932,25.157 22.312,34.891 24.417,34.891 30.368,24.652 24.435,15.126" />
					</svg>
				</button>
			</span> -->
		`
	}

	pageItemRemainHtmlTemplate() {
		return `
			<span class="page">
				<span class="paginate__link paginate__link--remain" aria-label="Page ...">{{itemTitle}}</span>
			</span>
		`
	}

	pageItemSelectedHtmlTemplate() {
		return `
			<span class="page current">
				<span class="paginate__link" aria-label="Page {{itemTitle}}, Current Page" aria-current="true">{{itemTitle}}</span>
			</span>
		`
	}

	pageItemHtmlTemplate() {
		return `
			<span class="page">
				<button type="button" data-jump-page-button data-page-num={{itemTitle}} class="paginate__link" aria-label="Page {{itemTitle}}">{{itemTitle}}</button>
			</span>
		`
	}

	buildToolbarLink(pageNumber) {
		if (!isNaN(pageNumber)) {
			const searchParams = new URLSearchParams(window.location.search)
			searchParams.set("page", pageNumber)
			const newUrl = window.location.pathname + '?' + searchParams.toString()
			return newUrl
		}

		const baseUrl = window.location.href.split('?')[0]
		return baseUrl
	}

	buildBottomPagination(currentPage, totalPages, numProductsPerPage, totalProducts) {
		var viewingLast = numProductsPerPage;

		if (totalProducts < numProductsPerPage) {
			viewingLast = totalProducts
		}

	  // If it has only one page, clear Pagination
		let paginationHtml = ''

    if (totalPages > 1) {
      if (currentPage > 1) {
        viewingLast = currentPage * numProductsPerPage
      }

      if (currentPage === totalPages) {
        viewingLast = totalProducts
      }

      var percentage = (100 * parseFloat(viewingLast)) / parseFloat(totalProducts)
      var progress = percentage < 100 ? `${percentage}%` : '100%'

      paginationHtml = this.paginationTemplate()

      var previousLink = currentPage - 1 === 1? window.location.href.split('?')[0] : this.buildToolbarLink(currentPage - 1)

      // Build Previous
      var previousHtml = (currentPage > 1) ? this.previousActiveHtmlTemplate() : this.previousDisabledHtmlTemplate()
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, previousLink)
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml)

      // Build Next
      var nextHtml = (currentPage < totalPages) ? this.nextActiveHtmlTemplate() : this.nextDisabledHtmlTemplate()
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink(currentPage + 1))
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml)

      // Create page items array
      var beforeCurrentPageArr = []
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore)
      }

      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...')
      }

      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1)
      }

      beforeCurrentPageArr.push(currentPage)

      var afterCurrentPageArr = []
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPages; iAfter++) {
        afterCurrentPageArr.push(iAfter)
      }

      if (currentPage + 3 < totalPages) {
        afterCurrentPageArr.push('...')
      }

      if (currentPage + 3 <= totalPages) {
        afterCurrentPageArr.push(totalPages)
      }

      // Build page items
      var pageItemsHtml = ''
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr)
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += this.pageItemRemainHtmlTemplate()
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? this.pageItemSelectedHtmlTemplate() : this.pageItemHtmlTemplate()
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage])
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink(pageArr[iPage]))
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml)
      paginationHtml = paginationHtml.replace(/{{viewingLast}}/g, viewingLast)
      paginationHtml = paginationHtml.replace(/{{totalProduct}}/g, totalProducts)
      paginationHtml = paginationHtml.replace(/{{progress}}/g, progress)
    }

    const $bottomPagination = document.querySelector(this.selector.bottomPagination);
    if ($bottomPagination) $bottomPagination.innerHTML = paginationHtml;
  }

	buildPagination(totalProducts) {
		const urlParams = new URLSearchParams(window.location.search);

		// Get page info
		let currentPage = urlParams.get('page');

		if (!currentPage) {
			currentPage = 1;
		}

		if (isNaN(currentPage)) {
			currentPage = 1;
		} else {
			currentPage = parseInt(currentPage);
		}

		const numProductsPerPage = this.perPage;
		var totalPages = Math.ceil(totalProducts / numProductsPerPage);

		this.buildBottomPagination(currentPage, totalPages, numProductsPerPage, totalProducts);
	}

  sendCategoryNostoAnalytics(response, filters, sort, from) {
    const urlParams = new URLSearchParams(window.location.search);
    const searchQuery = urlParams.get('q');

    const type = window.isNostoSearchPage? 'serp' : 'category';
    const queryTerm = window.isNostoSearchPage? searchQuery : window.nostoCategoryPath;
    const query = {
      products: {
        sort: sort,
        filters: filters
      }
    };

    if (window.isNostoSearchPage) {
      query.query = queryTerm;
    }

    const searchResult = response.data.data.search;
    const filteredHits = [];

    if (searchResult) {
      if (searchResult.hasOwnProperty('redirect')) {
        delete searchResult['redirect'];
      }

      if (searchResult.products) {
        if (!isNaN(from)) {
          searchResult.products.from = from;
        }

        if (!window.isNostoSearchPage && window.shopifyCollection) {
          if (window.shopifyCollection.id) {
            searchResult.products.categoryId = window.shopifyCollection.id.toString();
          }
        }

        if (searchResult.products.hits) {
          searchResult.products.hits.forEach(product => filteredHits.push({productId: product.productId}));
          searchResult.products.hits = filteredHits;

          this.addClickTracking(searchResult.products.hits, type);
        }
      }
    }

    const options = {
      isKeyword: false
    };

    if (!window.nostojs) {
      (function() {
        const name = 'nostojs';
        window[name] = window[name] || function(cb) {
          (window[name].q = window[name].q || []).push(cb);
        }
      })();
    }

    window.nostojs(api => {
      api.recordSearch(
        type,
        query,
        searchResult,
        options
      );
    });
  }

	// record nosto click through event
  addClickTracking(hits, type) {
  const searchResultsContainer = document.querySelector('[data-nosto-collection]');
    if (!searchResultsContainer) return;
    searchResultsContainer.addEventListener('click', event => {
      const clickedElement = event.target.closest('[data-product-id]');

      if (!clickedElement) return;
      const productId = clickedElement.dataset.productId;
      const hit = hits.find(hit => hit.productId === productId);

      if (!hit) return;
      window.nostojs(api => {
      api.recordSearchClick(type, hit);
      });
    });
  }
}

// Initialize
if (!window.disableNosto) {
	window.collectionJS = new Collection()
}
